import { render } from "./CadastroComGrid.vue?vue&type=template&id=c7d4ae7a&scoped=true&ts=true"
import script from "./CadastroComGrid.vue?vue&type=script&lang=ts"
export * from "./CadastroComGrid.vue?vue&type=script&lang=ts"

import "./CadastroComGrid.vue?vue&type=style&index=0&id=c7d4ae7a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7d4ae7a"]])

export default __exports__